<template>
  <v-dialog :value="value" @input="input => $emit('input', input)" width="350">
    <v-card>
      <v-card-title>Novo projeto</v-card-title>
      <v-card-text class="pt-6 pb-1">
        <v-text-field
          v-model="form.name"
          label="Nome do projeto"
          outlined
          hide-details
        ></v-text-field>
        <zp-select-domain
          class="mt-5"
          v-model="form.domain_id"
        ></zp-select-domain>
        <zp-pixel-select
          class="mt-5"
          v-model="form.pixels"
          label="Pixels"
          placeholder="Selecione"
          :multiple="true"
        ></zp-pixel-select>
        <v-text-field
          class="mt-5"
          label="WhatsApp padrão"
          placeholder="+00 00 00000-0000"
          v-model="form.phone"
          outlined
          hide-details
        ></v-text-field>
      </v-card-text>
      <v-card-actions class="pr-5 pl-5 pb-5 pt-6">
        <v-btn color="secondary" depressed light block :loading="loading" @click="save()">Criar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ZpSelectDomain from '@/components/SelectDomain'
import ZpPixelSelect from '@/components/Pixel/Select'

export default {
  props: ['value'],
  components: {
    ZpSelectDomain,
    ZpPixelSelect
  },
  data () {
    return {
      form: {
        name: '',
        pixels: [],
        phone: '',
        domain_id: null
      },
      loading: false
    }
  },
  methods: {
    async save () {
      if (!this.form.name) {
        return false
      }

      this.loading = true
      try {
        await this.$store.dispatch('projects/store', {
          ...this.form,
          pixels: this.form.pixels.map(item => item.id)
        })
        this.form = {
          name: '',
          pixels: []
        }
      } catch (e) {
        alert('Oops! Ocorreu um erro ao criar o seu projeto.')
      }
      this.loading = false
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
